
import { AppState } from '@/types';
import { TIERS } from '@/lib/tierSystem';
import { getGlobalWeekStart } from '@/utils/globalWeekUtils';

export const getWeekStart = getGlobalWeekStart;

export const initialState: AppState = {
  user: null,
  isAuthenticated: false,
  totalPoints: 0,
  activityCredits: 0,
  weeklyGoal: 300,
  weeklyStartDate: getWeekStart(),
  currentWeekPoints: 0,
  monthlyStartDate: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
  currentMonthPoints: 0,
  activities: [],
  streak: 0,
  lastStreakDate: null,
  activitiesLoggedToday: 0,
  activityCounts: {
    "Set": 0,
    "Story": 0,
    "Closed": 0,
    "Hangout": 0,
    "Opening": 0,
    "Roleplay": 0,
    "Call": 0,
    "Admin": 0,
    "Closing": 0,
    "Referral": 0,
    "Client Servicing": 0
  },
  badges: [],
  currentTier: TIERS[0], // Start with Rookie tier
  leaderboardPosition: {
    daily: 1,
    weekly: 1
  },
  petCollection: null,
  virtualPet: null,
  // Simplified pet system
  simplePet: null,
  lastLoginDate: null,
  petInteractions: [],
  teamPets: [],
  challenges: [],
  activeChallenges: [],
  challengeFriends: [],
  challengeInvitations: [],
  weeklyGoalStreak: 0,
  lastWeekGoalAchieved: false,
  weeklyBonusEarned: 0,
  weeklySummaryShown: false,
  
  // Habitica system state
  habits: [], // Initialize empty habits array
  lastDailyReset: null,
  
  experience: 0,
  gold: 0,
  health: 100,
  maxHealth: 100,
  constitution: 1.0,
  damageDealt: 0,
  partyMembers: [],
  damageHistory: [],
  lastDamageCheck: new Date(),
  dayStartTime: new Date(),
  consecutiveDaysCompleted: 0,
  perfectDayStreak: 0
};
